import { render, staticRenderFns } from "./DevelopmentPermit.vue?vue&type=template&id=04c1d08c&scoped=true"
import script from "./DevelopmentPermit.vue?vue&type=script&lang=js"
export * from "./DevelopmentPermit.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentPermit.vue?vue&type=style&index=0&id=04c1d08c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1d08c",
  null
  
)

export default component.exports